import {EventBus} from "../../../shared/utilities/event-bus";
import OTP from "@/plugins/otpInput/OTP.vue";

const OtpPlugin = {
    install(Vue) {
        Vue.component("otpInput", OTP);
        Vue.prototype.$otpInput = {
            openOTP(params) {
                EventBus.$emit("openOTP", params);
            },
        };
    },
};

export default OtpPlugin;
